import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { Language } from '../interfaces/language.interface';
import { ApiResponse } from '../interfaces/api.models';

@Injectable({ providedIn: 'root' })
export class LanguageApiService {
  readonly #http = inject(HttpClient);
  readonly #baseUrl = environment.apiUrl;

  getAll(): Observable<Language[]> {
    return this.#http
      .get<ApiResponse<Language[]>>(`${this.#baseUrl}/languages`)
      .pipe(map((response) => response.data));
  }
}